
<div class="container">
    <div class="row">
        <div class="col-md-12">

            <h1>Backorders</h1>

            <div class="textfiltering">
                <i class="fa fa-search"></i><input type="text" placeholder="Filter backorders..." class="empty"/>
            </div>
            
            <app-backorder-table></app-backorder-table>

        </div>
    </div>
</div>

